import { Flex, Heading, Text } from "@chakra-ui/react";

/**
 * Component for displaying form headings with optional content
 * @param {Object} props - Component props
 * @param {string} props.title - The heading title
 * @param {string} props.content - Optional content text below the heading
 * @param {Object} props.styles - Chakra UI style object for the heading
 * @param {Object} props.wrapStyles - Chakra UI style object for the wrapper
 */
const FormHeading = ({ 
  title, 
  content, 
  styles, 
  wrapStyles 
}: { 
  title: string; 
  content?: string; 
  styles?: Record<string, any>; 
  wrapStyles?: Record<string, any>; 
}) => {
  return (
    <Flex flexDir={"column"} rowGap={"8px"} mb={"12px"} {...wrapStyles}>
      <Heading
        as={"h3"}
        fontSize={"16px"}
        textAlign={"center"}
        lineHeight={"1.2"}
        {...styles}
      >
        {title}
      </Heading>
      {content ? (
        <Text
          textAlign={"center"}
          fontSize={"14px"}
          lineHeight={"1.3"}
          letterSpacing={"0.28px"}
        >
          {content}
        </Text>
      ) : null}
    </Flex>
  );
};

export default FormHeading;
